export function getQueryString(name,urls) {
           let p=urls.split('?')[1];
           let params=new URLSearchParams(p)
           console.log(params.get(name),p,name) //1
           return params.get(name)
 }
export function getQueryHashString(name,urls) {
       let p=urls.split('#')[1];
       let params=new URLSearchParams(p)
       console.log(params.get(name),p,name) //1
       return params.get(name)
 }


import {roomleave} from '@/api/lz.js';
 export async function MyNewRouter(url){
   console.log('新路由跳转',url);
   if(location.href.search('roominfo') > 0 ){
    let result = await roomleave(window.nimleavelive);
    console.log('用户离开直播间行为',result.data);
    location.href = url
   }else{
     location.href = url
   }
   // location.href = 'http://t-new.longzhu.com'+ url
 }

 export function getQueryList(url){
   var theRequest = new Object();
   if (url.indexOf("?") != -1) {
     var str = url.substr(1);
     var strs = str.split("&");
     for (var i = 0; i < strs.length; i++) {
       theRequest[strs[i].split("=")[0]] = decodeURIComponent(
         strs[i].split("=")[1]
       );
     }
   }
   return  theRequest
 }

 export function myguid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0,
              v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
      });
  }

// 手机号验证
 export function checkTelephone(telephone) {
      var reg=/^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      if (!reg.test(telephone)) {
          return false;
      } else {
          return true;
      }
  }


//获取浏览器信息
export function getPosType() {
    let status = '';
    var agent = navigator.userAgent.toLowerCase();
    var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
        console.log("这是windows32位系统");
        status = 'windows'
    }
    if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
        console.log("这是windows64位系统");
        status = 'windows'
    }
    if (isMac) {
        console.log("这是mac系统");
        status = 'mac'
    }
    //判断操作系统信息
    if (/(Android)/i.test(navigator.userAgent)) {
        console.log('Android')
        status = 'Android'
    } else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        console.log('ios')
        status = 'ios'
    }
}

//判断当前环境是否是微信环境
export function is_weixin() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
}



 /**
   * 防抖
   * @param {function} fn 执行函数
   * @param {number} wait 等待时间，毫秒
   * @param {boolean} immediate 是否立即执行
   */
let DoTimeout = null;
 export function  debounce (fn, wait, immediate) {
    let DoTimeout; // 局部全局变量
    return function (...args) {
      let context = this;
      if (DoTimeout) clearTimeout(DoTimeout); // 清除计时器，但是DoTimeout本身还在，只是不会在执行

      if (immediate) { // 总是执行第一次操作
        let callNow = !DoTimeout; // 第一次为true
        // 多次操作，DoTimeout初始化，多次触发只有当wait等待时间结束DoTimeout才为空
        DoTimeout = setTimeout(function () {
          DoTimeout = null;
        }, wait);
        // 第一次为true, 执行
        if (callNow) fn.apply(context, args);
      } else { // 总是执行最后一次操作
        DoTimeout = setTimeout(function () {
          fn.apply(context, args);
        }, wait);
      }
    };
  }


// 姓名验证
export function checkName(name){
  var regName =/^[\u4e00-\u9fa5]{2,6}$/;
  if(!regName.test(name)){
      return false;
   }else{
      return true;
   }
}
// 身份证验证
export function isCardNo(card)
{
   // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
   var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
   if(reg.test(card) === false)
   {
       // alert("身份证输入不合法");
       return  false;
   }else{
      return true;
   }
}


   export function DiffTime(val){
      	let t1= moment(val * 1000);
      	let t2 = moment();
      	let status = '';
      	if(t2.diff(t1, 'day') > 0){
      	  let days =  t2.diff(t1, 'day');
      	  if(days >= 4){
      	    return moment(val * 1000).format('YYYY-MM-DD')
      	  }else{
      	    status = days +'天前'
      	    return status
      	  }

      	}
      	if(t2.diff(t1, 'hour') > 0){
      		status = t2.diff(t1, 'hour') +'小时前'
      		return status
      	}

      	if(t2.diff(t1, 'minutes') > 0){
      		status = t2.diff(t1, 'minutes') +'分钟前'
      		return status
      	}
      	if(t2.diff(t1, 'seconds') >= 0){
      		status = '刚刚'
      		return status
      	}
      	 // moment(val * 1000).format('YYYY-MM-DD HH:mm:ss')
      }


//  namespace：命名空间，visitPlanList=拜访计划  visitFeedbackList=拜访反馈
export const myLocalStorage = {
  set(namespace = 'visitPlanList', key, data, time) {
    const storage = JSON.parse(localStorage.getItem(namespace)) || {}
    storage[key] = {
      data,
      createTime: Date.now(),
      lifeTime: time ||  1000 * 60 * 10 * 1 * 1 // 1000 * 60 * 60 * 24 * 7 // 默认设置过期时间：7天
    }
    console.log('设置缓存',namespace);
    localStorage.setItem(namespace, JSON.stringify(storage))
  },
  get(namespace = 'visitPlanList', key) {
    const storage = JSON.parse(localStorage.getItem(namespace)) || {}
    if (!storage[key]) return
    const { data, createTime, lifeTime } = storage[key]
    console.log('读取缓存',namespace);
    // 当前时间 - 存入时间 > 过期时间
    if (Date.now() - createTime > lifeTime) {
      delete storage[key]
      localStorage.setItem(namespace, JSON.stringify(storage))
      return null
    } else {
      return data
    }
  },
  delete(namespace = 'visitPlanList', key) {
    const storage = JSON.parse(localStorage.getItem(namespace)) || {}
    if (!storage[key]) return
    delete storage[key]
    console.log('删除缓存',namespace);
    localStorage.setItem(namespace, JSON.stringify(storage))
  }
}


// 各主流浏览器
export function getBrowser() {
    var u = navigator.userAgent;
    var bws = [{
        name: 'sgssapp',
        it: /sogousearch/i.test(u)
    }, {
        name: 'wechat',
        it: /MicroMessenger/i.test(u)
    }, {
        name: 'weibo',
        it: !!u.match(/Weibo/i)
    }, {
        name: 'uc',
        it: !!u.match(/UCBrowser/i) || u.indexOf(' UBrowser') > -1
    }, {
        name: 'sogou',
        it: u.indexOf('MetaSr') > -1 || u.indexOf('Sogou') > -1
    }, {
        name: 'xiaomi',
        it: u.indexOf('MiuiBrowser') > -1
    }, {
        name: 'baidu',
        it: u.indexOf('Baidu') > -1 || u.indexOf('BIDUBrowser') > -1
    }, {
        name: '360',
        it: u.indexOf('360EE') > -1 || u.indexOf('360SE') > -1
    }, {
        name: '2345',
        it: u.indexOf('2345Explorer') > -1
    }, {
        name: 'edge',
        it: u.indexOf('Edge') > -1
    }, {
        name: 'ie11',
        it: u.indexOf('Trident') > -1 && u.indexOf('rv:11.0') > -1
    }, {
        name: 'ie',
        it: u.indexOf('compatible') > -1 && u.indexOf('MSIE') > -1
    }, {
        name: 'firefox',
        it: u.indexOf('Firefox') > -1
    }, {
        name: 'safari',
        it: u.indexOf('Safari') > -1 && u.indexOf('Chrome') === -1
    }, {
        name: 'qqbrowser',
        it: u.indexOf('MQQBrowser') > -1 && u.indexOf(' QQ') === -1
    }, {
        name: 'qq',
        it: u.indexOf('QQ') > -1
    }, {
        name: 'chrome',
        it: u.indexOf('Chrome') > -1 || u.indexOf('CriOS') > -1
    }, {
        name: 'opera',
        it: u.indexOf('Opera') > -1 || u.indexOf('OPR') > -1
    }];

    for (var i = 0; i < bws.length; i++) {
        if (bws[i].it) {
            return bws[i].name;
        }
    }
    return 'other';
}

// 系统区分
export function getOS() {
    var u = navigator.userAgent;
    if (!!u.match(/compatible/i) || u.match(/Windows/i)) {
        return 'windows';
    } else if (!!u.match(/Macintosh/i) || u.match(/MacIntel/i)) {
        return 'macOS';
    } else if (!!u.match(/iphone/i) || u.match(/Ipad/i)) {
        return 'ios';
    } else if (!!u.match(/android/i)) {
        return 'android';
    } else {
        return 'other';
    }
}



export function Utf8ArrayToStr(){
     let str = '';
        let i = 0;
        const len = array.length;
        let char1 = 0;
        let char2 = 0;
        let char3 = 0;
        let char4 = 0;
        while (i < len) {
          char1 = array[i += 1];
          // 当单个字节时, 最大值 '01111111', 最小值 '00000000' 右移四位 07, 00
          // 当两个字节时, 最大值 '11011111', 最小值 '11000000' 右移四位 13, 12
          // 当三个字节时, 最大值 '11101111', 最小值 '11100000' 右移四位 14, 14
          if (char1 >> 4 <= 7) {
            str += String.fromCharCode(char1);
          } else if (char1 >> 4 === 12 || char1 >> 4 === 13) {
            char2 = array[i += 1];
            str += String.fromCharCode(((char1 & 0x1F) << 6) | (char2 & 0x3F));
          } else if (char1 >> 4 === 14) {
            char2 = array[i += 1];
            char3 = array[i += 1];
           char4 = ((char1 & 0x0F) << 12) | ((char2 & 0x3F) << 6);
            str += String.fromCharCode(char4 | ((char3 & 0x3F) << 0));
          }
        }
        return str;
}



// WEBPACK FOOTER //
// ./src/lib/tools.js